export default {
    publicUrl: '/maps-sdk-for-web/6.x/6.23.0//examples'
};
